import { InfoCircleOutlined } from '@ant-design/icons';
import type { Lens } from '@hookform/lenses';
import { Alert, Descriptions, Tooltip, Typography } from 'antd';
import { Watch } from 'react-hook-form';
import { useAuthority } from '../../me/hook';
import { videoModelSpecs, type VideoModelCode } from '../model-spec';

const ref_tip = (
  <>
    支持通过输入<Typography.Text keyboard>@</Typography.Text>
    字符来引用图片、视频、人像，例如
    <Typography.Text code>@图片1</Typography.Text>、
    <Typography.Text code>@视频1</Typography.Text>、
    <Typography.Text code>@人像1</Typography.Text>，
    <Typography.Text type="warning">注意：不支持真人视频参考</Typography.Text>
  </>
);

export const PromptTooltip = (props: { lens?: Lens<VideoModelCode> }) => {
  const authority = useAuthority();

  if (props.lens == null) {
    return null;
  }

  return (
    <div className="inline-flex items-center">
      <Tooltip
        classNames={{ root: 'min-w-fit' }}
        title={
          <div className="space-y-2">
            <Alert type="info" title={ref_tip}></Alert>
            <Alert type="warning" title="目前仅部分模型支持"></Alert>
            <Descriptions
              column={1}
              size="small"
              bordered
              items={videoModelSpecs
                .entries()
                .filter(([_, spec]) => !spec.deprecated)
                .filter(([_, spec]) => authority(spec.permission))
                .filter(([_, spec]) => spec.reference_image)
                .map(([model, spec]) => ({
                  key: model,
                  label: videoModelSpecs.get(model)?.name,
                  children: spec.reference_element ? '支持' : '不支持',
                }))
                .toArray()}
            ></Descriptions>
          </div>
        }
      >
        <InfoCircleOutlined className="ml-2"></InfoCircleOutlined>
      </Tooltip>
      <Watch
        {...props.lens.interop()}
        compute={(value) => {
          return !!videoModelSpecs.get(value)?.reference_element;
        }}
        render={(isSupported) =>
          isSupported && (
            <Typography.Text className="ml-2" type="secondary">
              Tip：当前模型{ref_tip}
            </Typography.Text>
          )
        }
      ></Watch>
    </div>
  );
};
